import React from 'react';
import clsx from 'clsx';
import { DivPropsWithoutRef } from '../../common/types';

export interface TableProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLTableElement>,
    HTMLTableElement
  > {
  className?: string;
  /**
   * Включать отступы в компонент
   */
  hasMargin?: boolean;
  /**
   * Произвольные классы элементов:
   * * table – элемент таблицы
   */
  classes?: {
    table?: string;
  };
  /**
   * Дополнительные стили корневого элемента
   */
  style?: React.CSSProperties;
  /**
   * Дополнительные пропы корневого элемента
   */
  rootProps?: DivPropsWithoutRef;
}

export const Table: React.FC<TableProps> = ({
  children,
  className,
  hasMargin,
  classes,
  style,
  rootProps,
  ...props
}) => {
  return (
    <div
      {...rootProps}
      className={clsx(
        'hse-Table',
        {
          'hse-Table_hasMargin': hasMargin
        },
        className,
        rootProps?.className
      )}
      style={{ ...style, ...rootProps?.style }}
    >
      <table className={clsx('hse-Table__table', classes?.table)} {...props}>
        {children}
      </table>
    </div>
  );
};
